export default (props, vars) => !!props?.['open'] && 'open';
